import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

class Animations {
    init() {
        this.drawSquares();
    }

    drawSquares() {
        gsap.registerPlugin(DrawSVGPlugin);

        document
            .querySelectorAll(".animation-square")
            .forEach((animationSquare) => {
                const rects = animationSquare.querySelectorAll("rect");

                gsap.timeline({
                    repeat: 0,
                    defaults: { duration: 3 },
                })
                    .set(animationSquare, { opacity: 1 })
                    .from(rects, { drawSVG: "0% 0%" });
            });
    }
}

export default Animations;
